import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatButtonModule, MatDialog, MatDialogModule, MatDialogRef, MatFormFieldModule, MatInputModule } from '@angular/material';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DialogoSiNoComponent } from './dialogo-si-no/dialogo-si-no.component';

export interface TableHeader {
  id: string;
  title: string;
}

@Component({
  selector: 'app-table-items',
  templateUrl: './table-items.component.html',
  styleUrls: ['./table-items.component.css']
})
export class TableItemsComponent implements OnInit {

  @Input('header') header: TableHeader[] = [];
  @Input('body') body: any[] = [];
  @Input('withOptions') withOptions: boolean = true;

  @Output('event') event: EventEmitter<string> = new EventEmitter<string>();
  @Output('itemSelected') itemSelected: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dNotificacionServicio: DNotificacionServicio
    ,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (this.withOptions) {
      const opExist = this.header.some(item => item.id === 'op');
      if (!opExist) this.header.push({id: 'op', title: 'Acciones'});
    }
  }

  editItem(index: number) {
    this.event.emit('edit');
    this.itemSelected.emit(index);
  }

  deleteItem(index: number) {
    //                                                     :string,:string,
    // this.dNotificacionServicio.mostrarDialogoSiNo(
    //   '¿Está seguro de eliminar esta información?',//title?
    //   'Al hacerlo no podrá recuperarla.',//mensaje?
    //   '',//mensajeDetallado?:string, 
    //   '',//colorToolbar?: string, 
    //   '#41d78c',//colorButtonConfirm?: string, 
    //   '#262944',//colorTextButtonConfirm?: string
    //   '#ffffff',//colorButtonCancel?: string, 
    //   '#262944'//colorTextButtonCancel?: string
    //   )
      
    const dialogRef = this.dialog.open(DialogoSiNoComponent);

    dialogRef
      .afterClosed().subscribe(res => {
      if (!res) return;
      this.body.splice(index, 1);
      this.event.emit('delete');
      this.itemSelected.emit(index);
    });
  }

}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/table-items/table-items.component.ts